export type AcademicYearDefaults = { name: string; startDate: string; endDate: string };

/** Standard Indian academic year (1 Apr - 31 Mar) that contains `today` (UTC calendar). */
export function suggestIndianAcademicYear(today: Date = new Date()): AcademicYearDefaults {
  const month = today.getUTCMonth() + 1;
  const startYear = month >= 4 ? today.getUTCFullYear() : today.getUTCFullYear() - 1;
  const endYear = startYear + 1;
  return {
    name: `${startYear}-${String(endYear % 100).padStart(2, "0")}`,
    startDate: `${startYear}-04-01`,
    endDate: `${endYear}-03-31`,
  };
}

/** Client-side mirror of the API rule so the form can fail fast; the API stays authoritative. */
export function validateAcademicYearDates(values: {
  startDate?: string;
  endDate?: string;
}): string | null {
  if (!values.startDate || !values.endDate) return null;
  return values.endDate <= values.startDate ? "End date must be after the start date" : null;
}
